import {
    RelativeDateRangeFilter,
    RelativeDateRangeFilterResult,
} from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/filters/RelativeDateRangeFilter";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";
import type { IRelativeDateRange, IRelativeDateRangeOptions } from "app/pages/sales-intelligence/types/range";

import type { IAppsFilterOptionsDto } from "../../types/descriptionDto";
import { appsFilterCategoryMap } from "../../types/filterCategory";

const createReleaseDateFilter = (description: IAppsFilterOptionsDto): SearchFilterInstance => ({
    key: "releaseDate",
    trackingName: "App Release Date",
    apiCategory: "appsFilters",
    category: appsFilterCategoryMap.apps,
    title: { key: "si.find_apps.filters.releaseDate.title" },
    tooltipText: { key: "si.find_apps.filters.releaseDate.tooltip" },
    filter: new FilterPanelBaseFilter<IRelativeDateRange, IRelativeDateRangeOptions>({
        options: description.releaseDate,
    }),
    filterView: RelativeDateRangeFilter,
    filterResultView: RelativeDateRangeFilterResult,
});

export default createReleaseDateFilter;
